import { has, isNil } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import RoutePrefixContext from '../../../../new/contexts/RoutePrefixContext';
import { API_KEY_RESOURCE_TYPES } from 'js/constants/resourceTypes';
import DateUtils from '../../../lib/DateUtils';
import { sanitizeApiKey } from 'js/lib/URLUtils';
import CopyText from '../../elements/CopyText';

class APIKeyOverviewTab extends React.Component {
  static contextType = RoutePrefixContext;

  render() {
    const { data } = this.props;
    const createdDate = DateUtils.convertDateStringToFormat(data.created_at);
    const lastUpdate = DateUtils.convertDateStringToFormat(data.updated_at);

    let resourceInfoLink = '';
    if (
      !isNil(data.resourceType) &&
      !isNil(data.resourceId) &&
      has(API_KEY_RESOURCE_TYPES, data.resourceType)
    ) {
      let resourceInfo = { ...API_KEY_RESOURCE_TYPES[data.resourceType] };
      resourceInfo['resourceId'] = data.resourceId;

      resourceInfoLink = !isNil(resourceInfo.route) ? (
        <div>
          <b>{`${resourceInfo.displayName}: `}</b>
          <Link to={`${this.context}${resourceInfo.route}/${resourceInfo.resourceId}`}>
            {resourceInfo.resourceId}
          </Link>
        </div>
      ) : (
        <div>
          <b>{`${resourceInfo.displayName}: `}</b>
          {resourceInfo.resourceId}
        </div>
      );
    }

    return (
      <div className="tab-content data-map-overview-tab">
        <section>
          <div className="detail-row">
            <div className="detail-col">
              <div className="detail-key">API Key</div>
              <div className="detail-value">
                <CopyText baseText={data.api_key} displayText={sanitizeApiKey(data.api_key)} />
              </div>
            </div>
            <div className="detail-col">
              <div className="detail-key">API Key ID</div>
              <div className="detail-value">{data.id}</div>
            </div>
          </div>
          <div className="detail-row">
            <div className="detail-col">
              <div className="detail-key">Key For Resource</div>
              <div className="detail-value">{resourceInfoLink}</div>
            </div>
            <div className="detail-col">
              <div className="detail-key">Created On</div>
              <div className="detail-value">{createdDate}</div>
              <div className="detail-key">Last Updated On</div>
              <div className="detail-value">{lastUpdate}</div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default APIKeyOverviewTab;
